import { ResourceName } from "@/types";
import { getResourceIcon } from "@/utils/icons";
import { IconButton, Tooltip } from "@mui/material";

interface ViewTasksButtonProps {
  onClick: () => void;
}

export const ViewTasksButton = ({ onClick }: ViewTasksButtonProps) => {
  const TaskIcon = getResourceIcon(ResourceName.TASKS);

  return (
    <Tooltip title="View Tasks">
      <IconButton onClick={onClick} sx={{ color: "text.secondary" }}>
        <TaskIcon />
      </IconButton>
    </Tooltip>
  );
};
